

export const colorChanger = (field: number) => {
	if (field >= 0) {
		 return 'rgb(78, 175, 10)';
	} else {
		 return 'red';
	}
};